import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartWaterfallAxis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChartWaterfallAxis"><Path d="M5 19H21V21H3V3H5V19Z" fill="currentColor"/><Path d="M21 17H19V11H21V17Z" fill="currentColor"/><Path d="M13 15H11V9H13V15Z" fill="currentColor"/><Path d="M17 14H15V8H17V14Z" fill="currentColor"/><Path d="M9 11H7V5H9V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChartWaterfallAxis;
